<template>
    <div class="projects">
        <template v-if="projects.length > 0">
            <ProjectCard v-for="project in projects" :key="project.id" :project="project" v-on="$listeners"/>
        </template>
        <template v-else>
            <slot name="empty"/>
        </template>
    </div>
</template>
<script>
import { SolutionConsumer, UserConsumer } from '../../mixins';
import { ProjectCard } from '../../components/shared';

export default {
    name: 'ProjectsList',
    components: { ProjectCard },
    mixins: [SolutionConsumer, UserConsumer],
    props: {
        projects: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.projects {
    @include container(20px);
    flex-grow: 1;
    padding: 0;
}
</style>
